import signInBanner from "../../../assets/images/icons/ic-signin.svg";
import {css} from "@emotion/css"
import {RouteInfo} from "../../../route/RouteHelper";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {LoginService} from "../../../connection-services/login/LoginService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useAuthDispatcher, useAuthState} from "../../../context/AuthContext";
import {setUserRefreshToken} from "../../../service/localStorage/LocalStorageService";
import {actionTypes, setLoginStateDispatch} from "../../../context/reducer";
import Recaptcha from "react-google-recaptcha";
import CountDownTimer from "../../../component/countDownTimer/CountDownTimer";
import {Helmet} from "react-helmet";
import {
    RaikoButtonPrimary,
    RaikoInputSubmitCode,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {writeNewToken} from "../../../service/authService/AuthService";


export default function SignInEnterSubmitCode() {

    const service = new LoginService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const {state} = useLocation()

    const [username, setUsername] = useState(state.username);
    const [password, setPassword] = useState(state.password);

    const [timerAmount, setTimerAmount] = useState(120);

    const [submitCode, setSubmitCode] = useState("");

    const dispatch = useAuthDispatcher()
    const {loginState} = useAuthState()
    const navigate = useNavigate()

    useEffect(() => {
        if (typeof loginState !== "undefined" && loginState) {
            navigate(RouteInfo.Dashboard.globalUrl, {replace: true})
        }
    }, [loginState])

    function validateEnterInfo() {
        loading.show()
        service.loginUser(username, submitCode)
            .then(response => {

                writeNewToken(response.data.access_token)
                setUserRefreshToken(response.data.refresh_token)

                dispatch(
                    setLoginStateDispatch(
                        actionTypes.LOGIN,
                        response.data.access_token,
                        "ADMIN"))
                // getAdminRolesFromServer(refreshToken, token)

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })

    }

    function getAdminRolesFromServer(refresh_token, access_token) {
        loading.show()
        service.getAccessInfo(access_token)
            .then(response => {
                setUserRefreshToken(refresh_token)
                dispatch(setLoginStateDispatch(
                    actionTypes.LOGIN,
                    access_token,
                    response.permissions))
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleSendSmsAgain() {
        handleGenerateRecaptcha()
            .then(key => {

                loading.show()
                service.sendVerificationCode(username, password, key)
                    .then(response => {
                        setTimerAmount(120)
                        showSuccessMessage("کد تایید با موفقیت ارسال شد.")
                    }).catch(reason => {
                    showErrorMessage(detectServerErrorMessage(reason))
                }).finally(_ => {
                    loading.hide()
                })

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    const reCaptchaRef = useRef(undefined);
    const [recaptchaGeneratedKey, setRecaptchaGeneratedKey] = useState(null);

    const handleGenerateRecaptcha = () => {
        return new Promise(async (resolve, reject) => {

            if (recaptchaGeneratedKey) {
                setRecaptchaGeneratedKey(null)
                window.grecaptcha.reset();
            }

            let newVar = await reCaptchaRef.current.executeAsync();

            resolve(newVar)
        })
    }

    return (
        <>
            <Helmet>
                <title>{RouteInfo.SignInEnterSubmitCode.name}</title>
            </Helmet>

            <div className={"signInEnterPhoneContainer"}>
                <div className={"pageTitleContainer"}>
                    <img src={signInBanner} alt="ic signin"/>
                    <span className={"title"}>کد تایید</span>
                </div>
                <form className={"signInContentContainer"}>
                    <p className={"signInTitle"}>لطفا کد تایید ارسال شده را وارد نمایید.</p>
                    <div className={"editInfoContainer"}>
                        <Link className={"editPhoneNumber"} to={RouteInfo.SignInEnterPhoneNumber.url}>
                            <div className={"ic-edit"}></div>
                            <span>ویرایش اطلاعات ورود</span>
                        </Link>

                    </div>
                    <RaikoInputSubmitCode
                        handleCheckCode={validateEnterInfo}
                        labelText={""}
                        value={submitCode}
                        getCodeValue={setSubmitCode}
                    />

                   {/* <Recaptcha
                        ref={reCaptchaRef}
                        className={'g-recaptcha'}
                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                        render={"explicit"}
                        size={"invisible"}
                        onChange={setRecaptchaGeneratedKey}
                        hl={"fa"}
                    />*/}

                    <RaikoButtonPrimary
                        label={"ورود به سامانه"}
                        className={css`width: 100%`}
                        onClick={validateEnterInfo}/>


                    <span className={"timerContainer"}>
                        <CountDownTimer firstTimeInSeconds={timerAmount} endTimeClickedEvent={handleSendSmsAgain}
                                        endTimeMessage={"ارسال مجدد"}/>
                </span>

                </form>
            </div>
        </>
    )
}